import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import { BulletIcon } from "../../icons/BulletIcon";
export const RequiredIcon = styled(BulletIcon) `
  vertical-align: super;
  display: inline;
`;
export const RequiredFieldIndicator = forwardRef((props, ref) => (_jsx(RequiredIcon, { "data-testid": "RequiredFieldIndicator", ref: ref, palette: "expressiveInformative", size: "0.286em" // 4px at default 14px
    , ...props })));
RequiredFieldIndicator.displayName = "RequiredFieldIndicator";
